module.exports = __webpack_public_path__ + "media/images/icons/rss-alt-3f2a5f9580353b6c73cd8152f534c516.svg";